<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="row h-100 d-flex justify-content-center">
        <div class="col h-100 ancho-col">
          <card-item class="striped-tabled-with-hover" style="height: 70%">
            <template slot="header">
              <div class="container">
                <div class="row">
                  <div
                    class="col-3 margin-config form-group form-group-sm d-flex justify-content-start align-items-center"
                  >
                    <input
                      id="filtros"
                      v-model="filtros"
                      class="form-check-inline"
                      type="checkbox"
                      style="zoom: 1.2"
                    />
                    <label class="label" for="filtros"> Mostrar Filtros</label>
                  </div>
                  <div
                    class="col-6 margin-config d-flex justify-content-center align-items-center"
                  >
                    <h3 class="card-title">Módulo de Pagos</h3>
                  </div>
                  <div class="col-3 margin-config d-flex justify-content-end">
                    <button
                      @click="ingresarPagoRapipago"
                      class="btn btn-primary"
                    >
                      Pagos rapipago
                    </button>
                  </div>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row" v-if="filtros">
                <div class="col-12 col-sin-padding ancho-fijo mx-auto">
                  <div class="container-fluid">
                    <div class="row d-flex justify-content-center">
                      <div
                        class="col-10 form-group form-group-sin-margen form-group-sm"
                      >
                        <label class="label" for="vehiculo"
                          >Filtrar clientes
                        </label>
                        <div class="card filtro-card">
                          <div class="card-body card-b-reducido">
                            <div class="container h-100 w-100">
                              <div
                                class="row d-flex align-items-center justify-content-around"
                                style="margin-bottom: 0 !important"
                              >
                                <div
                                  class="col-3 form-group form-group-sin-margen form-group-sm d-flex align-items-center"
                                >
                                  <input
                                    id="sinContratos"
                                    v-model="sinContratos"
                                    class="form-check-inline"
                                    type="checkbox"
                                    style="zoom: 1.2"
                                  />
                                  <label class="label" for="sinContratos"
                                    >sin contratos</label
                                  >
                                </div>

                                <div
                                  class="col-6 form-group form-group-sin-margen form-group-sm"
                                >
                                  <SelectorLugarCobranza
                                    v-model="idCobranzaLugarPago"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row d-flex justify-content-center">
                <div
                  class="col-8 form-group form-group-sm cliente-selector col-sin-padding"
                >
                  <label class="label" for="grupo">Cliente</label>
                  <SelectorClienteVigente
                    ref="selectorCliente"
                    v-model="cliente"
                    :idCobranzaLugarPago="idLugarPagoSeleccionado"
                    :incluirSoloSinContrato="sinContratos"
                    :isLoadingExternal="isFiltroCargando"
                  />
                </div>
                <div
                  class="col-8 form-group form-group-sm col-sin-padding"
                  v-if="cliente && situacionCliente"
                >
                  <template v-if="!isLoading">
                    <div class="d-flex justify-content-start">
                      <label for="">situacion del cliente</label>
                    </div>

                    <card-item class="striped-tabled-with-hover">
                      <div class="container">
                        <div class="row">
                          <div class="col-12 d-flex justify-content-center">
                            <table
                              style="width: 80%; margin: 2%; margin-bottom: 5%"
                            >
                              <tr>
                                <td>Deuda anterior</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(
                                      this.situacionCliente.deuda_anterior,
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Última factura</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(
                                      this.situacionCliente.ultima_factura,
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Pagos periodo actual</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(
                                      this.situacionCliente.pagosPeriodoActual,
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Deuda real</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(this.situacionCliente.deuda_real)
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Último Pago Ingresado
                                  <small class="font-weight-bold text-success">
                                    {{ formatUltimoPagoVirtual }}
                                  </small>
                                </td>
                                <td style="text-align: end">
                                  {{ formatUltimoPago }}
                                  {{
                                    formatM(
                                      this.situacionCliente.ultimoPagoMonto,
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Movimientos del mes</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(
                                      this.situacionCliente.movimientos_del_mes,
                                    )
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Saldo a la fecha</td>
                                <td style="text-align: end">
                                  {{
                                    formatM(this.situacionCliente.SaldoALaFecha)
                                  }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>

                        <div class="row">
                          <button
                            @click="verFactura"
                            style="margin: 0 auto; display: block"
                            data-transition="fade"
                            class="btn btn-lg btn-primary"
                            type="button"
                          >
                            Ver última factura
                          </button>
                          <VerFacturaModal
                            :situacionCliente="situacionCliente"
                          />
                        </div>
                      </div>
                    </card-item>
                  </template>
                  <template v-else>Cargando...</template>
                </div>

                <div
                  v-if="situacionCliente && !isLoading"
                  class="col-12 form-group form-group-sm d-flex justify-content-end"
                >
                  <IngresarPagoEnModuloDePagosModal
                    :situacionCliente="situacionCliente"
                    @update="update"
                  />
                  <SaldoAlMesSiguente
                    :situacionCliente="situacionCliente"
                    @update="update"
                  />
                  <div
                    v-if="situacionCliente || (this.filtros && this.cliente)"
                    class="container d-flex justify-content-between"
                  >
                    <div class="row">
                      <div
                        class="col-12 button-group d-flex justify-content-around"
                      >
                        <button @click="verEstadoDeCuenta" class="btn btn-info">
                          Ver estado de cuenta
                        </button>
                        <button
                          @click="verHistorialDeCliente"
                          class="btn btn-secondary"
                        >
                          Ver historial de tickets
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-12 button-group d-flex justify-content-around"
                      >
                        <button
                          @click="saldoAlMesSiguiente"
                          class="btn btn-warning"
                        >
                          Pasar saldo al mes siguiente
                        </button>
                        <button @click="ingresarPago" class="btn btn-success">
                          Ingresar pago
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
import VerFacturaModal from "./VerFacturaModal";
import IngresarPagoEnModuloDePagosModal from "./IngresarPagoEnModuloDePagosModal.vue";
import SaldoAlMesSiguente from "./SaldoAlMesSiguienteModal.vue";

import SelectorClienteVigente from "../Clientes/shared/SelectorClienteVigente.vue";
import axios from "axios";
import { formatM } from "../../lib/utils/accountingJsFns";
import moment from "moment";
import SelectorLugarCobranza from "../Clientes/shared/SelectorLugarCobranza.vue";
export default {
  name: "PagosPage",
  components: {
    SelectorClienteVigente,
    VerFacturaModal,
    IngresarPagoEnModuloDePagosModal,
    SaldoAlMesSiguente,
    SelectorLugarCobranza,
  },
  data: () => ({
    situacionCliente: null,
    isLoading: true,
    cliente: null,
    filtros: false,
    sinContratos: false,
    idCobranzaLugarPago: null,
    isFiltroCargando: false,
  }),
  mounted() {
    this.cliente = null;
  },
  computed: {
    idLugarPagoSeleccionado() {
      return this.idCobranzaLugarPago &&
        this.idCobranzaLugarPago.id_cobranza_lugarPago
        ? this.idCobranzaLugarPago.id_cobranza_lugarPago
        : null;
    },
    formatUltimoPagoVirtual() {
      if (this.situacionCliente && this.situacionCliente.fecha_pago_virtual) {
        const fechaPagoVirtual = moment(
          this.situacionCliente.fecha_pago_virtual,
        ).format("DD/MM/YYYY HH:mm A");
        return ` (Virtual vto: ${fechaPagoVirtual} ) `;
      }
      return "";
    },
    formatUltimoPago() {
      if (this.situacionCliente && this.situacionCliente.UltimoPago) {
        const ultimoPago = moment(this.situacionCliente.UltimoPago).format(
          "DD/MM/YYYY HH:mm A",
        );
        return ` [ ${ultimoPago} ] `;
      }
      return "";
    },
  },
  methods: {
    formatM: formatM,
    update() {
      this.getData();
    },
    verEstadoDeCuenta() {
      if (this.situacionCliente && this.situacionCliente.id_cliente) {
        const url = `${window.location.origin}/#/admin/clientes/${this.situacionCliente.id_cliente}/cuenta`;
        window.open(url, "_blank");
      } else {
        this.$msgBoxOk("No se ha seleccionado un cliente válido.");
      }
    },
    verHistorialDeCliente() {
      if (this.situacionCliente && this.situacionCliente.id_cliente) {
        const url = `${window.location.origin}/#/admin/suspensiones/evitar/${this.situacionCliente.id_cliente}/historial`;
        window.open(url, "_blank");
      } else {
        this.$msgBoxOk("No se ha seleccionado un cliente válido.");
      }
    },
    ingresarPagoRapipago() {
      this.$router.push(`/admin/pagos/rapipago`);
    },
    ingresarPago() {
      this.$bvModal.show("ingresar-pago-en-modulo-de-pagos-modal");
    },
    saldoAlMesSiguiente() {
      this.$bvModal.show("saldo-al-mes-siguiente");
    },
    verFactura() {
      this.$bvModal.show("ver-factura-modal");
    },
    async getData() {
      this.isLoading = true;
      const resp = await axios.post("/execute", {
        method: "CLI.GetSituacionDeCliente",
        parameters: [
          {
            name: "id_cliente",
            value: this.cliente.id_cliente,
          },
        ],
      });
      if (resp.data.ok) {
        this.situacionCliente = get(resp, "data.result[0][0]", []);
      } else {
        this.$msgBoxOk(resp.message);
      }
      this.isLoading = false;
    },
    resetClienteConLoading() {
      this.isFiltroCargando = true;
      this.cliente = null;
      this.situacionCliente = null;
      this.$nextTick(() => {
        setTimeout(() => {
          this.isFiltroCargando = false;
        }, 280);
      });
    },
  },
  watch: {
    cliente(val) {
      if (val) {
        this.isLoading = true;
        this.getData().then((data) => {
          if (get(data, "ok", true) === false) {
            this.$msgBoxOk(data.message);
          }
          this.isLoading = false;
        });
      } else {
        this.situacionCliente = null;
        this.isLoading = false;
      }
    },
    filtros(newVal) {
      if (!newVal) {
        this.sinContratos = false;
        this.idCobranzaLugarPago = null;
      }
      this.resetClienteConLoading();
    },
    sinContratos() {
      this.resetClienteConLoading();
    },
    idCobranzaLugarPago() {
      this.resetClienteConLoading();
    },
  },
};
</script>

<style scoped>
tr {
  border-bottom: 1px solid #ddd;
}
.filtro-card {
  /* padding: 0.3rem !important; */
  margin-bottom: 0.3rem !important;
  font-size: 0.2rem !important; /* achica el texto */
}

.filtro-card label {
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}
.filtro-card .row > div {
  padding-right: 5px !important;
  padding-left: 5px !important;
}

.form-group-sin-margen {
  margin-bottom: 0 !important;
  padding: 0 !important;
}
.card-b-reducido {
  padding: 0.5rem !important;
}

.cliente-reducido {
  padding: 0px 15px 10px 15px !important;
}
.col-sin-padding {
  padding: 0 !important;
}
.boton-pagos-rapipago {
  /* margin-right: 10px; */
  /* padding: 1rem 1rem !important;  */
  font-size: 1rem !important;
  min-width: unset;
  height: 50% !important;
  line-height: 1 !important;
}
.margin-config {
  margin: 1% 0 1% 0 !important;
}
.margin-config .label {
  margin: 0 !important;
}
.form-check-inline {
  margin-right: 0.5rem !important;
}
.ancho-col {
  width: 95% !important;
  max-width: none !important;
}
</style>
